function updateInStockCounts() {

    let fetchButton = document.getElementById("fetch-in-stock-count");
    if (!fetchButton) return;

    let collectionHandle = fetchButton.getAttribute("data-collection-url").split("/").pop(); // Extract collection handle
    let baseUrl = `/collections/all/products.json`;
    let variantCounts = {}; // Store counts per variant filter

    async function fetchAllProducts(page = 1) {
        let response = await fetch(`${baseUrl}?page=${page}`);
        let data = await response.json();
        if (!data.products || data.products.length === 0) {
            updateFilterCounts(); // Update UI after fetching all products
            return;
        }

        // data.products.forEach(product => {
        //     product.variants.forEach(variant => {
        //         if (variant.available) { // ✅ Check if variant is in stock
        //             let options = [variant.option1, variant.option2, variant.option3].filter(Boolean); // Get valid options
                        
        //             options.forEach(option => {
        //                 let key = option.toLowerCase(); // Create a unique key (e.g., "35", "Flats", "Gold")
        //               const transformedKey = key.replace(/\s+/g, '-');  

        //                 if (!variantCounts[transformedKey]) {
        //                     variantCounts[transformedKey] = 0;
        //                 }
        //                 variantCounts[transformedKey]++; // Increment count
        //             });
        //         }
        //     });
        // });
      console.log('data',data);
          data.products.forEach(product => {
            let countedOptions = new Set(); // ✅ Track counted options per product

            product.variants.forEach(variant => {
                if (variant.available) { // ✅ Check if variant is in stock
                    let options = [variant.option1, variant.option2, variant.option3].filter(Boolean); // Get valid options

                    options.forEach(option => {
                        let key = option.toLowerCase().replace(/\s+/g, '-'); // Transform key (e.g., "Size 35" → "size-35")

                        if (!countedOptions.has(key)) { // ✅ Ensure product is counted only once per option
                            countedOptions.add(key);

                            if (!variantCounts[key]) {
                                variantCounts[key] = 0;
                            }
                            variantCounts[key]++; // ✅ Count the product, not the variant
                        }
                    });
                }
            });
        });
        if (data.products.length === 30) { // Shopify returns 50 products per page, fetch next page
            fetchAllProducts(page + 1);
        } else {
            updateFilterCounts();
        }
    }

function updateFilterCounts() {
    console.log("variantCounts", variantCounts);

    document.querySelectorAll("[id^='count-']").forEach(countElement => {
        let key = countElement.id.replace("count-", "");
        countElement.innerText = variantCounts[key] || 0; // Default to 0 if key doesn't exist
    });

    console.log("Updated counts on page:", document.querySelectorAll("[id^='count-']"));
}

    fetchAllProducts(); // Start fetching products
};



// ✅ Run when page loads initially
document.addEventListener("DOMContentLoaded", updateInStockCounts);

// ✅ Manually trigger function when a filter checkbox is clicked
document.addEventListener("filterChanged", function (event) {
    // if (event.target.matches(".facets__form input[type='checkbox']")) { // Adjust to your theme’s filter class
        console.log("Filter checkbox clicked! Updating counts...");
        updateInStockCounts();
    // }
});


